/**
 * Local wishlist for Snoozyn
 */
if (window.snoozynWishlistLoaded) {
  // wishlist.js was included more than once on this page (e.g. once
  // site-wide in theme.liquid and again inside a section). Re-running
  // this file would attach a second click listener to document and
  // cause every wishlist click to toggle twice, effectively undoing
  // itself. Bail out so the listeners are only ever bound once.
  console.warn('Snoozyn wishlist: wishlist.js was loaded more than once on this page; skipping duplicate init.');
} else {
  window.snoozynWishlistLoaded = true;
  initSnoozynWishlist();
}

function initSnoozynWishlist() {
const WISHLIST_STORAGE_KEY = 'snoozyn-wishlist';

class SnoozynWishlist {
  static getItems() {
    try {
      return JSON.parse(localStorage.getItem(WISHLIST_STORAGE_KEY) || '[]');
    } catch {
      return [];
    }
  }

  static saveItems(items) {
    try { localStorage.setItem(WISHLIST_STORAGE_KEY, JSON.stringify(items)); } catch {}
    document.dispatchEvent(new CustomEvent('snoozyn:wishlist-updated', { detail: { items } }));
  }

  static has(productId) {
    return SnoozynWishlist.getItems().some((item) => String(item.id) === String(productId));
  }

  static toggle(product) {
    const items = SnoozynWishlist.getItems();
    const index = items.findIndex((item) => String(item.id) === String(product.id));

    if (index >= 0) {
      items.splice(index, 1);
    } else {
      items.push({
        id: product.id,
        handle: product.handle,
        title: product.title,
        url: product.url,
        image: product.image,
        price: product.price,
      });
    }

    SnoozynWishlist.saveItems(items);
    return index < 0;
  }

  static remove(productId) {
    const items = SnoozynWishlist.getItems().filter((item) => String(item.id) !== String(productId));
    SnoozynWishlist.saveItems(items);
  }

  static updateUI() {
    const items = SnoozynWishlist.getItems();
    const count = items.length;

    document.querySelectorAll('[data-wishlist-count]').forEach((el) => {
      el.textContent = count;
      el.classList.toggle('hidden', count === 0);
    });

    document.querySelectorAll('[data-wishlist-toggle]').forEach((btn) => {
      const id = btn.dataset.productId;
      const active = SnoozynWishlist.has(id);
      const addLabel = btn.dataset.wishlistLabelAdd || 'Add to wishlist';
      const removeLabel = btn.dataset.wishlistLabelRemove || 'Remove from wishlist';
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      btn.setAttribute('aria-label', active ? removeLabel : addLabel);
    });
  }
}

function initWishlist() {
  SnoozynWishlist.updateUI();
}

// Attach once (works across section reloads + theme editor)
document.addEventListener('click', (e) => {
  const btn = e.target.closest('[data-wishlist-toggle]');
  if (!btn) return;

  e.preventDefault();
  e.stopPropagation();

  const product = {
    id: btn.dataset.productId,
    handle: btn.dataset.productHandle,
    title: btn.dataset.productTitle,
    url: btn.dataset.productUrl,
    image: btn.dataset.productImage,
    price: btn.dataset.productPrice,
  };

  SnoozynWishlist.toggle(product);
  SnoozynWishlist.updateUI();
});

document.addEventListener('snoozyn:wishlist-updated', () => SnoozynWishlist.updateUI());

// Initial + Shopify events
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initWishlist);
} else {
  initWishlist();
}

// Shopify theme editor / dynamic sections
document.addEventListener('shopify:section:load', initWishlist);
document.addEventListener('shopify:section:select', initWishlist);
window.addEventListener('pageshow', initWishlist);

window.SnoozynWishlist = SnoozynWishlist;
}
